import KnowledgeBaseLayout from "./layout/KnowledgeBaseLayout.jsx";

const KnowledgeBaseManager = () => <KnowledgeBaseLayout />;

export default KnowledgeBaseManager;
